var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-top":"20px"}},[_vm._v(" "+_vm._s(_vm.$t("barcode.infoTH").format(_vm.brandConfig.display))+" ")]),_c('img',{staticStyle:{"width":"100%"},attrs:{"id":"barcode"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }